import React, { useRef, useState } from "react";
import {
  Card,
  Image as AntdImage,
  Upload,
  Modal,
  notification,
  Button,
  Alert,
  Typography,
  Space,
  Empty,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";

import ImgCrop from "antd-img-crop";
import useCreate from "hooks/useCreate";
import { useAuth } from "context/providers/auth";
import cropAndResizeToBase64 from "helpers/cropAndResizeToBase64";
import { handleErrors } from "helpers/api";

const Logotype = () => {
  const ref = useRef();
  const {
    state: {
      user: { company: data },
    },
    updateCompany,
  } = useAuth();

  const [preview_image, setPreviewImage] = useState(null);
  const [delete_issue_image_id, setDeleteLogotype] = useState(null);

  const path = "/companies";

  const { create } = useCreate({
    path,
    success_message: "Zaktualizowano logo firmy",
    onSuccess: (company_data) => {
      setDeleteLogotype(false);
      updateCompany(company_data);
    },
  });

  const handleCustomUpload = async ({ file, onSuccess }) => {
    try {
      const base64 = await cropAndResizeToBase64(file, 480, 120);
      await create({ logotype: base64 });
      onSuccess("ok");
    } catch (error) {
      notification.error({ message: handleErrors(error) });
    }
  };

  const handlePreview = async (file) => setPreviewImage(file.url);

  const handleDelete = () => create({ logotype: null });

  const beforeUpload = (file) => {
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      notification.error({
        message: "Plik jest za duży",
        description: "Maksymalny rozmiar pliku to 5MB.",
      });
    }
    return isLt5M || Upload.LIST_IGNORE; // zablokuje dodanie pliku
  };

  return (
    <Card
      title="Logo"
      extra={
        !data?.logotype_url && (
          <Button
            type="primary"
            icon={<UploadOutlined />}
            onClick={() => ref?.current?.click()}
          >
            Dodaj logo
          </Button>
        )
      }
    >
      {!!preview_image && (
        <AntdImage
          wrapperStyle={{
            display: "none",
          }}
          preview={{
            visible: true,
            onVisibleChange: () => setPreviewImage(null),
            afterOpenChange: (visible) => !visible && setPreviewImage(false),
          }}
          src={preview_image}
        />
      )}
      {delete_issue_image_id && (
        <Modal
          style={{ top: 45 }}
          title="Potwierdzenie"
          open={true}
          onOk={handleDelete}
          onCancel={() => setDeleteLogotype(false)}
          cancelText="Anuluj"
          okText="Potwierdzam"
          okType="danger"
        >
          Czy na pewno chcesz usunąć logo?
        </Modal>
      )}
      {!data?.logotype_url && (
        <>
          <Alert
            className="ant-alert-default"
            message={
              <Space direction="vertical">
                <Typography.Text>
                  Dostępne formaty: <strong>png, jpeg, gif, webp</strong>
                </Typography.Text>
                <Typography.Text>
                  Maksymalny rozmiar pliku: <strong>5 MB</strong>
                </Typography.Text>
                <Typography.Text>
                  Maksymalna szerokość: <strong>480px</strong>
                </Typography.Text>
                <Typography.Text>
                  Maksymalna wysokość: <strong>120px</strong>
                </Typography.Text>
              </Space>
            }
          />
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Brak danych"
          />
        </>
      )}
      <ImgCrop
        modalTitle="Przytnij obraz"
        rotationSlider
        aspect={480 / 120}
        quality={1}
        showReset
        resetText="Resetuj"
      >
        <Upload
          accept="image/jpeg,image/png,image/gif,image/webp"
          beforeUpload={beforeUpload}
          maxCount={1}
          customRequest={handleCustomUpload}
          onPreview={handlePreview}
          style={{ display: "none" }}
          fileList={
            data?.logotype_url
              ? [
                  {
                    uid: "-1",
                    name: "image.png",
                    status: "done",
                    url: data.logotype_url,
                  },
                ]
              : []
          }
          listType="picture"
          onRemove={() => setDeleteLogotype(true)}
        >
          <Button
            ref={ref}
            type="primary"
            htmlType="button"
            icon={<UploadOutlined />}
          >
            Dodaj logo
          </Button>
        </Upload>
      </ImgCrop>
    </Card>
  );
};

export default Logotype;
